import React from 'react';
import Avatar from 'components/Avatar';

import './styles.css';

interface TenantCellTypes {
  primaryTenant: any;
  secondaryTenant?: any;
}

const TenantCell = ({primaryTenant = {}, secondaryTenant}: TenantCellTypes) => (
  <div className="tenant">
    <Avatar
      className="avatar"
      url={primaryTenant.internalAvatarCropped || primaryTenant.avatarCropped}
      initials={primaryTenant.initials}
      width={50}
    />
    <div className="names">
      <div className="primary">{primaryTenant.fullName}</div>
      {secondaryTenant && (
        <div className="secondary">{secondaryTenant.fullName}</div>
      )}
    </div>
  </div>
);

export default TenantCell;
